import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var sidebox = {
  name: "bophd5",
  styles: "position:relative;width:320px;"
};
export var inner = /*#__PURE__*/css("padding:16px 8px 20px;border:1px solid ", colors.neutral.trim.default, ";text-align:center;");
export var button = {
  name: "1l4b1zv",
  styles: "width:100%;margin:0 0 8px;"
};
export var phoneButton = /*#__PURE__*/css(button, ";", designTokenFonts.bodyBold, ";");
export var applyOnlineContainer = /*#__PURE__*/css("border-radius:2px;border:1px solid ", colors.neutral.trim.default, ";border-top:0;");
export var applyOnlineButton = {
  name: "8atqhb",
  styles: "width:100%;"
};